import React, { useEffect, useState } from "react";
import * as yup from "yup";
import Swal from "sweetalert2";
import { DialogActions } from "@material-ui/core";
import AppForm from "../../../../partials/content/Forms/AppForm";
import {
  FormSelectField,
  FormTextField,
} from "../../../../partials/content/Forms/FormField";
import DialogLayout from "../../../../partials/content/DialogLayout";
import SearchCustomer from "../customers/searchCustomer";
import { useFormikContext } from "formik";
import { saveLicense } from "../../../../services/sales/salesService";
const licenseFormSchema = () => {
  return yup.object().shape({
    ID: yup.number(),
    customerName: yup.string().required(),
  });
};
function LicenseForm({ licenseImp = { ID: 0 }, onConfirmSave, onCloseDialog }) {
  const [license, setLicense] = useState({
    ID: 0,
    licenseKey: "",
    globalCustomerID: 0,
    customerName: "",
    globalCustomerLevel: 1,
    globalCustomerDeploymentType: 1,
    globalCustomerBillingType: 1,
    platformVersion: "",
    origin: "",
    host: "",
    hostname: "",
    port: "",
    protocol: "",
  });
  useEffect(() => {
    if (licenseImp.ID > 0) {
      setLicense(licenseImp);
    }
  }, [licenseImp.ID]);
  return (
    <React.Fragment>
      <AppForm
        initialValues={license}
        validationSchema={licenseFormSchema}
        onSubmit={async (values, { setStatus, setSubmitting }) => {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          })
            .fire({
              title: "Are you sure want to save this License ?",
              text: "Please note that you are responsible for this action",
              icon: "question",
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
              cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
              reverseButtons: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                saveLicense(values).then((response) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Saved",
                    html: response.data.message,
                    icon: "success",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                  const { data } = response.data;
                  setLicense(data.license);
                  //onConfirmSave();
                });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Cancelled",
                  text: "No change has been made",
                  icon: "info",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              }
            });
        }}
      >
        <LicenseFormContent />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              onCloseDialog();
            }}
          >
            <i className="fas fa-window-close"></i>
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-success btn-md btn-pill btn-bold"
          >
            <i className="fas fa-save"></i>
            Save
          </button>
        </DialogActions>
      </AppForm>
    </React.Fragment>
  );
}

export default LicenseForm;

const LicenseFormContent = () => {
  const [openSearchCustomer, setOpenSearchCustomer] = useState(false);
  const { setFieldValue } = useFormikContext();
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <FormTextField label="License Key" name="licenseKey" readonly />
          <FormTextField
            label="Customer"
            name="customerName"
            searchButton
            readonly
            onSearchClick={() => {
              setOpenSearchCustomer(true);
            }}
          />
          <FormSelectField
            label="Global Customer Level"
            name="globalCustomerLevel"
            options={[
              { value: 1, label: "Silver Customer" },
              { value: 2, label: "Gold Customer" },
              { value: 3, label: "Platinum Customer" },
              { value: 4, label: "Custom Customer" },
            ]}
          />
          <FormSelectField
            label="Deployment Type"
            name="globalCustomerDeploymentType"
            options={[
              { value: 1, label: "On-Cloud" },
              { value: 2, label: "On-Premise" },
            ]}
          />
          <FormSelectField
            label="Billing Type"
            name="globalCustomerBillingType"
            options={[
              { value: 1, label: "Monthly Billing" },
              { value: 2, label: "Yearly Billing" },
            ]}
          />
          <FormTextField label="Origin" name="origin" />
          <FormTextField label="Host" name="host" />
          <FormTextField label="Host Name" name="hostname" />
          <FormTextField label="Port" name="port" />
          <FormTextField label="Protocol" name="protocol" />
        </div>
      </div>
      <DialogLayout
        open={openSearchCustomer}
        title="Search Customer"
        onCloseDialog={() => {
          setOpenSearchCustomer(false);
        }}
        maxWIdth="md"
      >
        <SearchCustomer
          onSelectCustomer={(customer) => {
            setFieldValue("globalCustomerID", customer.ID);
            setFieldValue("customerName", customer.customerName);
            setOpenSearchCustomer(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );
};
